import { useAtomValue } from "jotai";
import { IsMobileAtom } from "../../App";

const SupportalHeader = ({
  open,
  toggleOpen,
}: {
  open: boolean;
  toggleOpen: () => void;
}) => {
  const isMobile = useAtomValue(IsMobileAtom);

  return (
    <div
      className={`d-flex justify-content-between mr-2`}
      style={{ marginTop: isMobile ? 5 : 55 }}
    >
      {open && (
        <div className="tw:flex tw:items-center tw:pl-2">
          <i
            className={`mdi mdi-lifebuoy tw:text-primary`}
            style={{ fontSize: 22 }}
          />
          <h3 className={`tw:mb-0 tw:pl-2 tw:text-dark`}>Supportal</h3>
        </div>
      )}
      <div
        className={`link-hovered ml-2 ${
          !open ? "sidebar-link  px-2 py-1 text-center" : "sidebar-toggler"
        }`}
        onClick={toggleOpen}
        style={{ width: open ? "auto" : "43px" }}
      >
        {open ? (
          <i className="mdi mdi-menu-open sidebar-icon cursor-pointer" />
        ) : (
          <i
            className="mdi mdi-menu sidebar-icon cursor-pointer"
            style={{ fontSize: 18 }}
          />
        )}
      </div>
    </div>
  );
};

export default SupportalHeader;
